import React, { useEffect } from 'react';
import CloseIcon from 'src/assets/icons/close.svg';
import { appendModalToDom } from 'helpers/modal';
import { bodyNoScroll } from 'helpers/utilities';
import { createPortal } from 'react-dom';
import { Overlay, Wrap } from './Pane.styled';

const configuratorModalEl = appendModalToDom('configurator-modal', { zIndex: 10001 });

const Pane = ({ children, onClose }) => {
  useEffect(() => {
    configuratorModalEl.style.display = 'block';
    bodyNoScroll.add();

    return () => {
      bodyNoScroll.remove();
      configuratorModalEl.style.display = 'none';
    };
  }, []);

  return createPortal(
    <>
      <Overlay onClick={onClose} />
      <Wrap>
        <CloseIcon onClick={onClose} />
        {children}
      </Wrap>
    </>,
    configuratorModalEl
  );
};

export default Pane;
